import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogFooter,
} from "@/components/ui/dialog";
import { TradingAccount } from "@/lib/api/otc";
import { Customer } from "@/lib/api/reports";
import { ContractType } from "@/lib/api/otc";
import {
  ContractForm,
  useBearStore,
} from "@/section/otc/ContractForm";
import { useOtcContractFormHandlers } from "./useOtcContractFormHandlers";

interface OtcContractFormModalProps {
  isPreviewOnly?: boolean;
  isNew: boolean;
  customers: Customer[];
  accounts: TradingAccount[];
  refetchContracts: () => void;
}

export function OtcContractFormModal({
  isPreviewOnly,
  isNew,
  customers,
  accounts,
  refetchContracts,
}: OtcContractFormModalProps) {
  const isModalOpen = useBearStore((state) => {
    return isNew ? !!state.new_contract : !!state.editing_contract?.id;
  });
  const set_new_contract = useBearStore((state) => state.set_new_contract);
  const set_edit_contract = useBearStore((state) => state.set_edit_contract);
  const update_new_contract_field = useBearStore(
    (state) => state.update_new_contract_field,
  );
  const update_edit_contract_field = useBearStore(
    (state) => state.update_edit_contract_field,
  );
  const updateAttemptedSave = useBearStore(
    (state) => state.updateAttemptedSave,
  );

  const onUpdateStatus = (status?: boolean) => {
    if (isNew) {
      set_new_contract(
        status === true ? { contract_type: ContractType.Range } : undefined,
      );
    } else {
      set_edit_contract(status === true ? {} : undefined);
    }
  };

  const onCloseModal = () => {
    if (isNew) {
      set_new_contract(undefined);
    } else {
      set_edit_contract(undefined);
    }
  };

  const { onSubmitForm, isSaving } = useOtcContractFormHandlers({
    refetchContracts,
    onCloseModal,
    updateAttemptedSave,
  });

  const isUpdateForm = !isNew;

  return (
    <Dialog
      onOpenChange={onUpdateStatus}
      open={isModalOpen}
      defaultOpen={false}
    >
      {isNew && (
        <DialogTrigger asChild>
          <Button
            type="button"
            className="mr-4"
            disabled={isModalOpen}
            onClick={() => onUpdateStatus(true)}
          >
            New Contract
          </Button>
        </DialogTrigger>
      )}
      <DialogContent className="max-w-screen-2xl md:min-w-sm lg:min-w-[80vw] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {isPreviewOnly
              ? "Preview Contract"
              : isUpdateForm
                ? "Update Contract"
                : "New Contract"}
          </DialogTitle>
        </DialogHeader>
        <ContractForm
          isPreviewOnly={isPreviewOnly}
          accounts={accounts}
          customers={customers}
          isUpdateForm={!isNew}
          onEditField={
            isNew ? update_new_contract_field : update_edit_contract_field
          }
          onSubmit={(formData) =>
            onSubmitForm(formData, isUpdateForm)
          }
        />
        <DialogFooter className="sm:justify-start"></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

